var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaymentsIconLarge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 61 61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.222 44.358a4.593 4.593 0 0 0 4.593 4.593h43.63a4.593 4.593 0 0 0 4.594-4.593v-19.52a.574.574 0 0 0-.575-.573H5.797a.574.574 0 0 0-.574.574v19.519Zm37.89-5.167h6.89a1.722 1.722 0 0 1 0 3.445h-6.89a1.722 1.722 0 0 1 0-3.445Zm-28.704-9.185h18.37a1.722 1.722 0 1 1 0 3.444h-18.37a1.722 1.722 0 1 1 0-3.444Zm0 9.185h6.889a1.722 1.722 0 0 1 0 3.445h-6.89a1.722 1.722 0 0 1 0-3.445Z",
    fill: "#00BBA5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.039 16.801a4.593 4.593 0 0 0-4.593-4.592H9.815A4.593 4.593 0 0 0 5.222 16.8v3.445a.574.574 0 0 0 .574.574h51.668a.574.574 0 0 0 .575-.574V16.8Z",
    fill: "#10F0D5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsIconLarge);
export default __webpack_public_path__ + "static/media/payments-icon-large.a1d05835825c04eaba335848cd1259b1.svg";
export { ForwardRef as ReactComponent };